// extracted by mini-css-extract-plugin
module.exports = {"page":"LoginPage_page__2m0fx","card":"LoginPage_card__1TczE","title":"LoginPage_title__36ngE","form":"LoginPage_form__2eWPc","foot":"LoginPage_foot__1lPzx"};